import Bids from './Bids';
import Info from './Info';
import Templates from './Templates';
import Template from './Template';

export {
  Bids,
  Info,
  Templates,
  Template,
}



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Header/index.js